import React from "react"
import {useNavigate} from "react-router-dom"
import {CssBaseline, ThemeProvider} from "@mui/material"
import {Security} from "@okta/okta-react"
import {OktaAuth, toRelativeUrl} from "@okta/okta-auth-js"
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"

import {Pages} from "./Pages"
import {config} from "./config"

import {AgentProvider} from "@indebted/hooks/Agent"
import {NotificationProvider} from "@indebted/components/Notification"
import {theme} from "@indebted/theme"

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
		},
	},
})

const SecurityWrapper = ({children}: {children: React.ReactElement}) => {
	const navigate = useNavigate()

	const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
		navigate(toRelativeUrl(originalUri || "/", window.location.origin))
	}

	return (
		<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
			{children}
		</Security>
	)
}

const oktaAuth = new OktaAuth(config.oktaAuth)

const App = () => {
	window.onbeforeunload = () => {
		localStorage.setItem("lastpage", `${window.location.pathname}${window.location.search}`)
		return null
	}

	return (
		<QueryClientProvider client={queryClient}>
			<SecurityWrapper>
				<AgentProvider>
					<ThemeProvider theme={theme}>
						<CssBaseline />
						<NotificationProvider>
							<Pages />
						</NotificationProvider>
					</ThemeProvider>
				</AgentProvider>
			</SecurityWrapper>
		</QueryClientProvider>
	)
}

export {App}
